var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonCheckOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2346_4291)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67884 4.02599C7.98535 3.60722 8.16631 3.09077 8.16631 2.53205C8.16631 1.13364 7.03269 0 5.6343 0C4.23591 0 3.10229 1.13364 3.10229 2.53205C3.10229 3.0893 3.28231 3.6045 3.58735 4.02269C3.70528 4.18436 3.8419 4.33153 3.99403 4.46102C4.43588 4.83712 5.00859 5.06409 5.6343 5.06409C6.25738 5.06409 6.8279 4.83903 7.26899 4.46576C7.42232 4.33601 7.56002 4.18834 7.67884 4.02599ZM5.6343 4.31409C6.61847 4.31409 7.41631 3.51625 7.41631 2.53205C7.41631 1.54784 6.61847 0.75 5.6343 0.75C4.65014 0.75 3.85229 1.54784 3.85229 2.53205C3.85229 3.51625 4.65014 4.31409 5.6343 4.31409Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.58257 13.5939C4.77581 13.7246 2.74414 13.4751 0.719814 12.6641L0.719727 9.83203C0.719727 8.29297 1.43433 6.27344 3.63354 5.23047C5.01632 6.31641 6.68042 5.99219 7.62964 5.23047C7.84611 5.33258 8.06044 5.44911 8.27061 5.58529",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.66382,
    cy: 10,
    r: 3.625,
    stroke: "currentColor",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.589 8.58203L8.94214 11.418L7.73901 10.1289",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2346_4291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonCheckOutline);
export default __webpack_public_path__ + "static/media/person-check-outline.4e8052ed0ecf341a3e1919a4ad5ac0a0.svg";
export { ForwardRef as ReactComponent };